import * as React from 'react';

import Text from 'antd/lib/typography/Text';
import Space from 'antd/lib/space';
import styles from './styles/stepStyles';
import Tag from 'antd/lib/tag';
import { antGrey, tagStyle } from './styles/globalStyles';
import Tooltip from 'antd/lib/tooltip';
import { ReleaseEventsTimelineSection } from './releaseOverview/ReleaseTimelineSection';
import { ReleaseStepType } from '../types';
import { ReleaseTimelineSectionContext } from './timelineEvents/EventsTimeline';
import { Nullable, ReleaseComponentProps, StepRunComponentProps } from '../typescriptHelpers';
import { EmptyStateWrapper } from './releaseEmptyState/EmptyStateWrapper';

interface BetaLatestBuildProps extends ReleaseComponentProps {
    activeBuildStatusString: string;
    titleColor: string;
    activeBuildStatusDescription?: string;
    isExternalBuildStatus?: boolean;
    soakStartedAt?: string;
    soakFinishedAt?: string;
    soakDidFinishEarly: boolean;
    releaseStepType: ReleaseStepType;
    stepRunComponentProps: Nullable<StepRunComponentProps>;
}

const BetaLatestBuild = (props: BetaLatestBuildProps): JSX.Element => {
    const primaryStatusText = props.activeBuildStatusString;
    const secondaryStatusText = props.activeBuildStatusDescription;
    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginBottom: 24 }}>
            <EmptyStateWrapper
                appId={props.appId}
                releaseId={props.releaseId}
                featureSections={[]}
                releaseStepType={props.releaseStepType}
                shouldForceDisable
            >
                {(isReleaseFromScraper) => {
                    return (
                        <Space direction="vertical" style={{ paddingTop: 28 }}>
                            <Space size={16}>
                                <Text style={{ ...styles.stepContentStatusText, color: props.titleColor }}>
                                    {isReleaseFromScraper ? 'Beta testing completed' : primaryStatusText}
                                </Text>
                                {props.isExternalBuildStatus !== null && (
                                    <Tooltip
                                        title={
                                            props.isExternalBuildStatus ?
                                                'The external build status of your active build is shown because at least one external testing group or individual tester has been assigned to the active build.'
                                            :   'The internal build status of your active build is shown because no external testing groups or individual testers have been assigned to the active build.'
                                        }
                                    >
                                        <Tag
                                            color="white"
                                            style={{
                                                ...tagStyle,
                                                color: antGrey.grey6,
                                                fontWeight: 400,
                                                borderColor: antGrey.grey6,
                                            }}
                                        >
                                            {props.isExternalBuildStatus ? 'External' : 'Internal'}
                                        </Tag>
                                    </Tooltip>
                                )}
                            </Space>
                            {secondaryStatusText && (
                                <Text type="secondary">
                                    {isReleaseFromScraper ?
                                        'Beta soak period has ended and beta testing is now complete.'
                                    :   secondaryStatusText}
                                </Text>
                            )}
                        </Space>
                    );
                }}
            </EmptyStateWrapper>
            <ReleaseEventsTimelineSection
                orgId={props.orgId}
                appId={props.appId}
                stepRunId={props.stepRunComponentProps?.stepRunId}
                releaseId={props.releaseId}
                context={ReleaseTimelineSectionContext.ReleaseStep}
                releaseStepType={props.releaseStepType}
            />
        </div>
    );
};

export default BetaLatestBuild;
